
    import { makeI18n } from '@/shared/lib/i18n';
    const baseTranslation = undefined
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/modules/sidebar/vacancy-request-list/vacancy-request-list.vue', {"requests":{"ru_RU":"Заявки","en_US":"Requests"},"requests.not.found":{"ru_RU":"Заявок нет","en_US":"No requests"},"requests.show.more":{"ru_RU":"Раскрыть","en_US":"Show"},"requests.show.less":{"ru_RU":"Свернуть","en_US":"Hide"},"pending.vacancy.request":{"ru_RU":"{count, plural, =0 {0 заявок} one {# заявка} few {# заявки} many {# заявок} other {# заявки}}","en_US":"{count, plural, =0 {0 requests} one {# request} other {# requests}}"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component._i18n = makeI18n("src/modules/sidebar/vacancy-request-list/vacancy-request-list.vue", baseTranslation);
      Component.beforeCreate = addHook(Component.beforeCreate);
      delete Component._Ctor;
    }
  